// What the crew's top bar says about the connection (TZ 8, 15.3): online or not, and how
// many actions wait to be sent. The queue itself arrives in STAGE_5 5.6 (IndexedDB);
// until then it is a store that the queue will fill, and the bar already reads it.

import { useSyncExternalStore } from 'react';

import { queueStore } from './offline/queue';

function subscribeOnline(listener: () => void): () => void {
  window.addEventListener('online', listener);
  window.addEventListener('offline', listener);
  return () => {
    window.removeEventListener('online', listener);
    window.removeEventListener('offline', listener);
  };
}

/** Whether the browser thinks it has a network, following it as it changes. */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribeOnline, () => navigator.onLine, () => true);
}

// --- the actions waiting to be sent --------------------------------------------------------

/** How many actions the offline queue still holds (STAGE_5 5.6). */
export function useQueuedActions(): number {
  return useSyncExternalStore(queueStore.subscribe, queueStore.waiting, () => 0);
}
